// extracted by mini-css-extract-plugin
export var form = "_5d-0";